webpackJsonp([19],{

/***/ 108:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tx-page-title"
  }, [_vm._v("历届年会")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid content-style"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2025年会 · 广州\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2025.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2024年会 · 曼谷\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2024.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2023年会 · 广州\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2023.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2022年会 · 广州\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2022.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-right"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2021年会 · 广州\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2021.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2020年会 · 成都\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2020.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-right"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2019年会 · 新加坡\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2019.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2018年会 · 澳门\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2018.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-right"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2017年会 · 东京\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2017.jpg",
      "alt": ""
    }
  })])])])])])])
}]}

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(72);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(7)("0eebba0d", content, true);

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

var Vue = __webpack_require__(3);
var VueI18n = __webpack_require__(0);
Vue.use(VueI18n);

//import nls
var nls = __webpack_require__(4);
var defaultLocale = localStorage.getItem("defaultLocale");
if (defaultLocale == null) {
    defaultLocale = nls.defaultLocale;
}
var i18n = new VueI18n({
    locale: defaultLocale, // set locale
    messages : nls.text, // set locale messages
});

// 获取组件引用
// var testC = require('./components/App.vue');
var header_comp = __webpack_require__(2);
var body_comp = __webpack_require__(22);
var footer_comp = __webpack_require__(1);

window.vm = new Vue({
    i18n : i18n,  // VueI18n 插件
    el:"#app",
    components: {
        header_comp: header_comp,
        body_comp: body_comp,
        footer_comp: footer_comp
    }
});

// $(document).ready(function () {
//     $('#modal_video').on('hide.bs.modal', function () {
//         document.getElementById('video').pause();
//     });
// });


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(108),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 44:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


module.exports = {
    computed: {
        item_height: function () {
            return {
                item_height_zh: this.$i18n.locale != 'en_US',
                item_height_en: this.$i18n.locale == 'en_US'
            };
        }
    },
    mounted: function () {
        $('.item-detail').viewer({
            scalable: false,
            title: false,
            url: 'data-original'
        });
        window.pageTitle = {
            en_US: this.$i18n.messages.en_US.page_title_culture,
            zh_HK: this.$i18n.messages.zh_HK.page_title_culture,
            zh_CN: this.$i18n.messages.zh_CN.page_title_culture
        };
        window.setTitle(window.pageTitle[this.$i18n.locale]);
    }
};

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "body,html{position:relative;height:100%;font-size:12px}body:after{background-image:url(" + __webpack_require__(90) + ")}.content-style{padding:0 20px}@media (min-width:768px){.content-style{padding:0 20px}}@media (min-width:992px){.content-style{padding:0 0 80px}}.item-padding-left{padding:0 0 30px}@media (min-width:768px){.item-padding-left{padding:0 15px 20px 0}}@media (min-width:992px){.item-padding-left{padding:0 20px 20px}}@media (min-width:1200px){.item-padding-left{padding:0 20px 20px}}.item-padding-right{padding:0 0 30px}@media (min-width:768px){.item-padding-right{padding:0 0 20px 15px}}@media (min-width:992px){.item-padding-right{padding:0 20px 20px}}@media (min-width:1200px){.item-padding-right{padding:0 20px 20px}}.item{background:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}.item_height2_zh,.item_height_zh{height:auto}@media (min-width:768px){.item_height2_zh{height:455px}}@media (min-width:992px){.item_height2_zh{height:590px}}@media (min-width:1200px){.item_height2_zh{height:590px}}.item_height_en{height:auto}@media (min-width:992px){.item_height_en{height:350px}}@media (min-width:1200px){.item_height_en{height:350px}}.item-detail,.item-detail2{padding:25px}@media (min-width:768px){.item-detail2{padding:70px 25px 90px}}@media (min-width:992px){.item-detail2{padding:90px 25px 110px}}@media (min-width:1200px){.item-detail2{padding:90px 25px 110px}}.item-detail3{padding:25px 0}@media (min-width:768px){.item-detail3{padding:35px 30px 42px}}@media (min-width:992px){.item-detail3{padding:60px 25px 66px}}@media (min-width:1200px){.item-detail3{padding:60px 25px 75px}}.item-title{padding:14px 10px 10px 20px;background-color:#f3f5f7;color:#4a4a4a;font-size:13px}@media (min-width:768px){.item-title{padding:25px;background-color:#f3f5f7;color:#4a4a4a;font-size:14px}}@media (min-width:992px){.item-title{padding:25px;background-color:#f3f5f7;color:#4a4a4a;font-size:20px}}@media (min-width:1200px){.item-title{padding:25px;background-color:#f3f5f7;color:#4a4a4a;font-size:20px}}.item-subtitle{padding:0 30px;color:#4a4a4a;font-size:13px;font-weight:700}@media (min-width:768px){.item-subtitle{padding:0;color:#4a4a4a;font-size:14px;font-weight:700}}@media (min-width:992px){.item-subtitle{padding:0 20px;color:#4a4a4a;font-size:16px;font-weight:700}}@media (min-width:1200px){.item-subtitle{padding:0 20px;color:#4a4a4a;font-size:18px;font-weight:700}}.item-text{padding:10px 30px 0;color:#4a4a4a;font-size:13px;line-height:160%}@media (min-width:768px){.item-text{padding:20px 0 0;color:#4a4a4a;font-size:14px;line-height:170%}}@media (min-width:992px){.item-text{padding:20px;color:#4a4a4a;font-size:16px;line-height:170%}}@media (min-width:1200px){.item-text{padding:20px;color:#4a4a4a;font-size:18px;line-height:170%}}.item-title-icon{margin-right:18px;margin-bottom:5px}.item-splitter{display:none;margin:15px 0;width:40px;border-bottom:5px solid #d3a571}.section-title{color:#fff;margin:20px 0 10px;font-size:16px}@media (min-width:768px){.section-title{font-size:20px}}@media (min-width:992px){.section-title{margin:20px 20px 10px;font-size:20px}}@media (min-width:1200px){.section-title{margin:20px 20px 10px;font-size:26px}}.section-subtitle{color:#fff;margin:0 0 20px;font-size:14px}@media (min-width:768px){.section-subtitle{margin:0 0 20px;font-size:18px}}@media (min-width:992px){.section-subtitle{margin:0 20px 20px;font-size:18px}}@media (min-width:1200px){.section-subtitle{margin:0 20px 20px;font-size:20px}}.image-padding{padding:20px 0 0}@media (min-width:768px){.image-padding{padding:20px 0 0}}@media (min-width:992px){.image-padding{padding:20px 0 0}}@media (min-width:1200px){.image-padding{padding:20px 0 0}}.image-width{width:100%;height:300px;object-fit:cover}.bottom-style{margin:40px 0 20px}@media (min-width:768px){.bottom-style{margin:60px 0 80px}}", ""]);

// exports


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/bg.jpg?81c8aeeb82f6471e26dc32566c910917";

/***/ })

},[155]);


// WEBPACK FOOTER //
// js/culture_nh.bundle.js?a407be7ac1929266b1df